import { createStore } from "vuex";
const store = createStore({
  state() {
    return {
      userInfo: {},
      isShowSidebar: false,
      summary: { company: [], businessGroup: [], webinars: [], activity: [] },
      keyword: "",
      searchObject: {},
    };
  },
  mutations: {
    setUser(state, payload) {
      state.userInfo = payload;
    },
    setSummary(state, payload) {
      state.summary = payload;
    },
    showSidebar(state, payload) {
      state.isShowSidebar = payload;
    },
    keyword(state, payload) {
      
      state.keyword = payload;
    },
    setSearchObject(state, payload) {
      state.searchObject = payload;
    },
  },
  getters: {
    getUser(state) {
      return state.userInfo;
    },
    getShowSidebar(state) {
      return state.isShowSidebar;
    },
    getSummary(state) {
      return state.summary;
    },
    getSearchObject(state) {
      return state.searchObject;
    },
  },
  actions: {},
});

export default store;
